import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";
import translationBR from "./locales/br/translation.json";

const fallbackLng = ['es'];
const availableLanguages = ['es', 'en', 'br'];

const resources = {
    es: {
      translation: translationES
    },
    en: {
      translation: translationEN
    },
    br: {
      translation: translationBR
    }
  };

i18n
  .use(Backend) // load translations using http (default                                               public/assets/locals/en/translations)
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    resources, 
    fallbackLng, // fallback language is english.

    detection: {
      checkWhitelist: true, // options for language detection
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;